import { render, staticRenderFns } from "./dsxwxprice.vue?vue&type=template&id=70a077b0&scoped=true&"
import script from "./dsxwxprice.vue?vue&type=script&lang=js&"
export * from "./dsxwxprice.vue?vue&type=script&lang=js&"
import style0 from "./dsxwxprice.vue?vue&type=style&index=0&id=70a077b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a077b0",
  null
  
)

export default component.exports